/*
 * Algolia predictive search — redesign (feat/algolia-redesign).
 * Monkey-patches the theme's predictive-search element to render Algolia
 * results in three open states:
 *   - Desktop  : Product Suggestions + Collections rail | 4-col product grid
 *   - Mobile (focused/empty)  : Popular Searches + Browse Collections
 *   - Mobile (typing/results) : Products only (scrollable rows)
 * No-results uses the legacy default-collections empty state (restyled).
 */
(function () {
  'use strict';

  var MOBILE_BREAKPOINT = 1000; // must match the CSS stack point in algolia-search.css
  function isMobileViewport() {
    if (window.matchMedia) return window.matchMedia('(max-width: ' + (MOBILE_BREAKPOINT - 0.02) + 'px)').matches;
    return window.innerWidth < MOBILE_BREAKPOINT;
  }
  var EXCLUDED_TAGS = ['tag_module_item', 'add-on', '100% damage protection', 'membership'];
  var EXCLUDED_TITLE_PATTERNS = ['[customize product]', '{customize product}', 'add-on', '100% damage protection', 'membership'];

  // Shopify Algolia stores merchant tags on `tags` (not `_tags`).
  function buildExclusionFilters() {
    var parts = ['inventory_available:true'];
    EXCLUDED_TAGS.forEach(function (tag) {
      parts.push('NOT tags:"' + tag + '"');
    });
    return parts.join(' AND ');
  }

  var ICON_SEARCH =
    '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_2119_4089)"><path d="M14.6656 4.6665L8.99924 10.3329L5.6661 6.99971L1.33301 11.3328" stroke="#A1A1A1" stroke-width="1.33326" stroke-linecap="round" stroke-linejoin="round"/><path d="M10.666 4.6665H14.6658V8.66628" stroke="#A1A1A1" stroke-width="1.33326" stroke-linecap="round" stroke-linejoin="round"/></g><defs><clipPath id="clip0_2119_4089"><rect width="15.9991" height="15.9991" fill="white"/></clipPath></defs></svg>';
  var ICON_FOLDER =
    '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_2119_4123)"><path d="M3.99952 9.33299L4.99947 7.39976C5.10818 7.18387 5.27353 7.00159 5.47785 6.87242C5.68216 6.74326 5.91775 6.67207 6.1594 6.66647H13.3323M13.3323 6.66647C13.536 6.66611 13.7371 6.71242 13.9201 6.80185C14.103 6.89128 14.2631 7.02144 14.388 7.18235C14.5129 7.34326 14.5992 7.53064 14.6404 7.73011C14.6816 7.92958 14.6765 8.13583 14.6256 8.33304L13.599 12.3328C13.5247 12.6205 13.3565 12.8751 13.121 13.0563C12.8854 13.2375 12.5962 13.3348 12.2991 13.3328H2.66627C2.31266 13.3328 1.97354 13.1923 1.72351 12.9423C1.47348 12.6922 1.33301 12.3531 1.33301 11.9995V3.33332C1.33301 2.97972 1.47348 2.6406 1.72351 2.39057C1.97354 2.14053 2.31266 2.00006 2.66627 2.00006H5.26612C5.4891 1.99788 5.70906 2.05165 5.90588 2.15647C6.1027 2.26128 6.27009 2.41379 6.39272 2.60003L6.93269 3.39999C7.05409 3.58433 7.21936 3.73565 7.41367 3.84036C7.60797 3.94508 7.82524 3.99992 8.04596 3.99995H11.9991C12.3527 3.99995 12.6918 4.14042 12.9418 4.39045C13.1919 4.64049 13.3323 4.97961 13.3323 5.33321V6.66647Z" stroke="#A1A1A1" stroke-width="1.33326" stroke-linecap="round" stroke-linejoin="round"/></g><defs><clipPath id="clip0_2119_4123"><rect width="15.9991" height="15.9991" fill="white"/></clipPath></defs></svg>';

  /**
   * Adds the shared identity to a set of search params. Without it Algolia
   * derives a user from the IP and every search looks like a new person.
   *
   * Also tags the request as the autocomplete surface and, for driven
   * browsers and rendering crawlers, turns analytics off — see the
   * automation guard in snippets/algolia-config.liquid. Applied last so the
   * gate wins over any clickAnalytics the caller passed.
   */
  function withUser(params) {
    var shared = typeof window.rsAlgoliaSearchParams === 'function'
      ? window.rsAlgoliaSearchParams('autocomplete')
      : (typeof window.rsAlgoliaUser === 'function' ? window.rsAlgoliaUser() : {});
    for (var key in shared) {
      if (Object.prototype.hasOwnProperty.call(shared, key)) params[key] = shared[key];
    }
    return params;
  }

  function getConfig() {
    var cfg = window.algoliaConfig || {};
    if (typeof cfg === 'string') {
      try { cfg = JSON.parse(cfg); } catch (e) { cfg = {}; }
    }
    if (!cfg.app_id && window.algoliaShopify && window.algoliaShopify.config) {
      cfg = window.algoliaShopify.config;
    }
    return cfg || {};
  }

  function escAttr(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function escHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function formatPrice(value) {
    if (value == null || value === '') return '';
    if (window.Shopify && typeof Shopify.formatPresentmentPrice === 'function') {
      return Shopify.formatPresentmentPrice(value);
    }
    var num = typeof value === 'string' ? parseFloat(value.replace(/[^0-9.]/g, '')) : value;
    if (isNaN(num)) return '';
    return '$' + num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function getMinPrice(hit) {
    return hit.variants_min_price != null ? hit.variants_min_price : hit.price;
  }

  // Build Your Own configurators index with a $0 base variant (the real price
  // is assembled on the PDP). Those hits get no price line instead of "$0.00";
  // every other product has a positive price and renders as before.
  // Owner call 2026-09-23.
  function hasPrice(hit) {
    var raw = getMinPrice(hit);
    var num = typeof raw === 'string' ? parseFloat(raw.replace(/[^0-9.]/g, '')) : parseFloat(raw);
    return num > 0;
  }

  // Shoplift price testing: attribute string for JS-rendered price elements so
  // the Shoplift script can swap them for visitors in a test variant.
  function slPriceAttr(hit) {
    var pid = hit.id || hit.objectID || '';
    return pid ? ' data-sl-attribute-p="' + escAttr(pid) + '"' : '';
  }

  /* ── Product templates ─────────────────────────────────────── */

  function productHref(hit) {
    var handle = hit.handle || hit.product_handle || '';
    return handle ? '/products/' + handle : '';
  }

  function dataAttrs(hit, position, queryID, indexName) {
    var out = ' data-algolia-objectid="' + escAttr(hit.objectID || '') + '"';
    out += ' data-algolia-position="' + position + '"';
    // Recommend stamps a queryID per hit; chained models mean the panel-level
    // one is not always the right one.
    var hitQueryID = hit.__queryID || queryID;
    if (hitQueryID) out += ' data-algolia-queryid="' + escAttr(hitQueryID) + '"';
    if (indexName) out += ' data-algolia-index="' + escAttr(indexName) + '"';
    if (hit.__model) out += ' data-algolia-model="' + escAttr(hit.__model) + '"';
    if (hit.id != null) out += ' data-algolia-productid="' + escAttr(hit.id) + '"';
    return out;
  }

  function buildProductCardsDesktop(hits, queryID, indexName) {
    var html = '';
    for (var i = 0; i < hits.length; i++) {
      var hit = hits[i];
      var href = productHref(hit);
      if (!href) continue;
      var image = hit.image || hit.product_image || '';
      var title = hit.title || '';
      html += '<a class="algolia-card" href="' + escAttr(href) + '"' + dataAttrs(hit, i + 1, queryID, indexName) + '>';
      html += '<span class="algolia-card__media">';
      if (image) {
        html += '<img src="' + escAttr(image) + '" alt="' + escAttr(title) + '" loading="lazy" width="300" height="300">';
      }
      html += '</span>';
      html += '<span class="algolia-card__title">' + escHtml(title) + '</span>';
      if (hasPrice(hit)) {
        html += '<span class="algolia-card__price"' + slPriceAttr(hit) + '>' + formatPrice(getMinPrice(hit)) + '</span>';
      }
      html += '</a>';
    }
    return html;
  }

  function buildProductRowsMobile(hits, queryID, indexName, limit) {
    var html = '';
    var max = Math.min(hits.length, limit || 3);
    for (var i = 0; i < max; i++) {
      var hit = hits[i];
      var href = productHref(hit);
      if (!href) continue;
      var image = hit.image || hit.product_image || '';
      var title = hit.title || '';
      html += '<a class="algolia-row" href="' + escAttr(href) + '"' + dataAttrs(hit, i + 1, queryID, indexName) + '>';
      html += '<span class="algolia-row__media">';
      if (image) {
        html += '<img src="' + escAttr(image) + '" alt="' + escAttr(title) + '" loading="lazy" width="160" height="160">';
      }
      html += '</span>';
      html += '<span class="algolia-row__info">';
      html += '<span class="algolia-row__title">' + escHtml(title) + '</span>';
      if (hasPrice(hit)) {
        html += '<span class="algolia-row__price"><span class="algolia-row__price-prefix">From </span><span' + slPriceAttr(hit) + '>' + formatPrice(getMinPrice(hit)) + '</span></span>';
      }
      html += '</span>';
      html += '</a>';
    }
    return html;
  }

  /* ── Rail (suggestions / collections) ──────────────────────── */

  function buildRailGroup(title, items, showIcon) {
    if (!items || !items.length) return '';
    var html = '<div class="algolia-rail__group">';
    html += '<h3 class="algolia-rail__title">' + escHtml(title) + '</h3>';
    html += '<ul class="algolia-rail__list" role="list">';
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      var dataAttr;
      if (it.type === 'collection') {
        dataAttr = 'data-algolia-collection="' + escAttr(it.value) + '"';
        if (it.objectID) dataAttr += ' data-algolia-objectid="' + escAttr(it.objectID) + '"';
        if (it.position) dataAttr += ' data-algolia-position="' + it.position + '"';
        if (it.queryID) dataAttr += ' data-algolia-queryid="' + escAttr(it.queryID) + '"';
        if (it.indexName) dataAttr += ' data-algolia-index="' + escAttr(it.indexName) + '"';
      } else {
        dataAttr = 'data-algolia-suggestion="' + escAttr(it.value) + '"';
        if (it.objectID) dataAttr += ' data-algolia-objectid="' + escAttr(it.objectID) + '"';
        if (it.position) dataAttr += ' data-algolia-position="' + it.position + '"';
        if (it.queryID) dataAttr += ' data-algolia-queryid="' + escAttr(it.queryID) + '"';
        if (it.indexName) dataAttr += ' data-algolia-index="' + escAttr(it.indexName) + '"';
      }
      var icon = '';
      if (showIcon) icon = it.type === 'collection' ? ICON_FOLDER : ICON_SEARCH;
      html += '<li class="algolia-rail__item">';
      html += '<button type="button" class="algolia-rail__link" ' + dataAttr + '>';
      html += icon + '<span>' + escHtml(it.label) + '</span>';
      html += '</button></li>';
    }
    html += '</ul></div>';
    return html;
  }

  /* ── No-results empty state (legacy behavior, restyled) ────── */

  function buildEmptyState(query) {
    var cfg = getConfig();
    var cols = cfg.default_collections || [
      { handle: 'lighting', title: 'Lighting' },
      { handle: 'hardware', title: 'Hardware' },
      { handle: 'wall-panels', title: 'Wall Panels' }
    ];
    var html = '<div class="algolia-empty-state">';
    html += '<p class="algolia-empty-state__title">No results for &ldquo;' + escHtml(query || '') + '&rdquo;</p>';
    html += '<p class="algolia-empty-state__text">Try a different search term or browse our collections:</p>';
    html += '<div class="algolia-empty-state__links">';
    for (var i = 0; i < cols.length; i++) {
      html += '<a class="algolia-empty-state__link" href="/collections/' + escAttr(cols[i].handle) + '">' + escHtml(cols[i].title) + '</a>';
    }
    html += '</div></div>';
    return html;
  }

  /* ── Data → suggestion/collection item lists ───────────────── */

  // Real Query Suggestions hits carry objectID / position / queryID so the
  // chip click can be reported as clickedObjectIDsAfterSearch against the
  // suggestions index. The product-title fallback has no record behind it
  // and sends nothing.
  function suggestionItems(suggestions, fallbackHits, limit, queryID, indexName) {
    var items = [];
    var seen = {};
    if (suggestions && suggestions.length) {
      for (var i = 0; i < suggestions.length && items.length < limit; i++) {
        var q = suggestions[i].query;
        if (!q || seen[q]) continue;
        seen[q] = true;
        items.push({
          type: 'query', label: q, value: q,
          objectID: suggestions[i].objectID || '',
          position: items.length + 1,
          queryID: queryID || '',
          indexName: indexName || ''
        });
      }
    }
    if (!items.length && fallbackHits && fallbackHits.length) {
      for (var j = 0; j < fallbackHits.length && items.length < limit; j++) {
        var t = fallbackHits[j].title;
        if (!t || seen[t]) continue;
        seen[t] = true;
        items.push({ type: 'query', label: t, value: t });
      }
    }
    return items;
  }

  function collectionItems(collections, limit, queryID, indexName) {
    var items = [];
    var seen = {};
    if (!collections) return items;
    for (var i = 0; i < collections.length && items.length < limit; i++) {
      var col = collections[i];
      var handle = col.handle || col.objectID;
      var title = col.title;
      if (!handle || !title) continue;
      var key = handle.toLowerCase();
      if (seen[key] || key === 'membership' || title.toLowerCase() === 'membership') continue;
      seen[key] = true;
      // objectID/queryID are only present for live Algolia collection hits;
      // the static default_collections (empty-query rail) carry neither, so
      // their clicks stay unattributed rather than sending a bogus objectID.
      items.push({
        type: 'collection',
        label: title,
        value: '/collections/' + handle,
        objectID: col.objectID || '',
        position: items.length + 1,
        queryID: queryID || '',
        indexName: indexName || ''
      });
    }
    return items;
  }

  /* ── Layout builders ───────────────────────────────────────── */

  function panelOpen() {
    return '<div class="predictive-search predictive-search--algolia bg-theme-bg text-theme-text text-start">' +
      '<div class="predictive-search__scroller algolia-dropdown">';
  }
  function panelClose() {
    return '</div></div>';
  }

  /* Turn the open search into a full-bleed overlay: the form becomes a
     fixed full-width container (input row on top, panel beneath). We
     measure the form's in-flow top BEFORE adding the .algolia-overlay
     class, so the overlay pins exactly where the search bar sat. Once the
     class is set the form is fixed at that same top, so we only measure on
     the first render of an open session (the class is removed on close). */
  function setupOverlay(instance) {
    try {
      var form = instance && instance.querySelector('.search--algolia');
      if (!form || !form.getBoundingClientRect) return;
      if (!form.classList.contains('algolia-overlay')) {
        var rect = form.getBoundingClientRect();
        document.documentElement.style.setProperty('--algolia-form-top', Math.max(0, Math.round(rect.top)) + 94 + 'px');
        document.documentElement.style.setProperty('--algolia-panel-top', Math.max(0, Math.round(rect.bottom)) + 'px');
        form.classList.add('algolia-overlay');
      }
    } catch (e) { /* noop */ }
  }

  function buildDesktop(state, data) {
    var sugg = suggestionItems(data.suggestions, data.products, 6, data.suggestionsQueryID, data.suggestionsIndexName);
    var cols = collectionItems(data.collections, 4, data.collectionsQueryID, data.collectionsIndexName);
    var hasProducts = data.products && data.products.length > 0;

    var rail = '<aside class="algolia-rail">';
    rail += buildRailGroup('Product Suggestions', sugg, true);
    rail += buildRailGroup('Collections', cols, true);
    rail += '</aside>';

    var total = data.nbHits != null ? data.nbHits : (data.products ? data.products.length : 0);
    var countText;
    if (!state.query) countText = data.personalised ? 'Based on what you\u2019ve viewed' : 'Trending now';
    else if (hasProducts) countText = total.toLocaleString() + ' results for \u201c' + escHtml(state.query) + '\u201d';
    else countText = 'No results for \u201c' + escHtml(state.query) + '\u201d';

    var main = '<div class="algolia-main">';
    main += '<div class="algolia-main__header">';
    main += '<span class="algolia-main__count" role="status" aria-live="polite">' + countText + '</span>';
    main += '<a class="algolia-main__view-all" href="/search?q=' + encodeURIComponent(state.query || '') + '">View all</a>';
    main += '</div>';
    main += '<div class="algolia-grid">';
    if (hasProducts) {
      main += buildProductCardsDesktop(data.products.slice(0, 24), data.queryID, data.indexName);
    } else if (state.query) {
      main += buildEmptyState(state.query);
    }
    main += '</div>';
    main += '<div class="algolia-loading" role="status" aria-live="polite" hidden>Loading\u2026</div>';
    main += '</div>';

    return panelOpen() + rail + main + panelClose();
  }

  function buildMobileEmpty(state, data) {
    var sugg = suggestionItems(data.suggestions, data.products, 5, data.suggestionsQueryID, data.suggestionsIndexName);
    var cols = collectionItems(data.collections, 4, data.collectionsQueryID, data.collectionsIndexName);
    var rail = '<div class="algolia-rail">';
    rail += buildRailGroup('Popular Searches', sugg, true);
    rail += buildRailGroup('Browse Collections', cols, true);
    rail += '</div>';
    return panelOpen() + rail + panelClose();
  }

  function buildMobileResults(state, data) {
    var hasProducts = data.products && data.products.length > 0;
    var total = data.nbHits != null ? data.nbHits : (data.products ? data.products.length : 0);
    // The visible label stays "Products"; screen readers get the count.
    var announce = hasProducts
      ? total.toLocaleString() + ' results for \u201c' + state.query + '\u201d'
      : 'No results for \u201c' + state.query + '\u201d';

    var main = '<div class="algolia-main">';
    main += '<div class="algolia-main__header">';
    main += '<span class="algolia-main__count" role="status" aria-live="polite" data-announce="' + escHtml(announce).replace(/"/g, '&quot;') + '">Products</span>';
    main += '<a class="algolia-main__view-all" href="/search?q=' + encodeURIComponent(state.query || '') + '">View all ' + total.toLocaleString() + '</a>';
    main += '</div>';
    if (hasProducts) {
      main += '<div class="algolia-rows">' + buildProductRowsMobile(data.products, data.queryID, data.indexName, 24) + '</div>';
    } else {
      main += buildEmptyState(state.query);
    }
    main += '<div class="algolia-loading" role="status" aria-live="polite" hidden>Loading\u2026</div>';
    main += '</div>';

    // While typing on mobile we surface product results only — the query
    // suggestions rail is hidden to keep the results list focused.
    return panelOpen() + main + panelClose();
  }

  /* ── Combobox accessibility (WAI-ARIA) ─────────────────────────
     The panel is a rich two-column layout, so after each render we flatten
     the layout wrappers to role="presentation" and expose the real
     interactive results as flat listbox options with ids, so the input's
     aria-controls / aria-activedescendant combobox contract is valid and
     keyboard-navigable. */
  var A11Y_PRESENTATION = [
    '.predictive-search', '.predictive-search__scroller', '.algolia-dropdown',
    '.algolia-rail', '.algolia-rail__group', '.algolia-rail__list', '.algolia-rail__item',
    '.algolia-main', '.algolia-main__header', '.algolia-grid', '.algolia-rows',
    '.algolia-empty-state', '.algolia-empty-state__links'
  ].join(', ');
  var A11Y_OPTIONS = '.algolia-rail__link, .algolia-card, .algolia-row, .algolia-empty-state__link, .algolia-main__view-all';

  function comboOptionLabel(opt) {
    if (opt.classList.contains('algolia-main__view-all')) {
      return opt.textContent.trim() || 'View all search results';
    }
    if (opt.classList.contains('algolia-rail__link')) {
      var t = opt.textContent.trim();
      return opt.hasAttribute('data-algolia-collection')
        ? 'Browse collection: ' + t
        : 'Search suggestion: ' + t;
    }
    if (opt.classList.contains('algolia-card') || opt.classList.contains('algolia-row')) {
      var titleEl = opt.querySelector('.algolia-card__title, .algolia-row__title');
      var priceEl = opt.querySelector('.algolia-card__price, .algolia-row__price');
      var title = titleEl ? titleEl.textContent.trim() : '';
      var price = priceEl ? priceEl.textContent.trim() : '';
      return (title + (price ? ', ' + price : '')).trim();
    }
    return opt.textContent.trim();
  }

  function enhanceComboboxA11y(instance) {
    var container = instance.results;
    if (!container) return;
    container.querySelectorAll(A11Y_PRESENTATION).forEach(function (el) {
      el.setAttribute('role', 'presentation');
    });
    // Group headings aren't valid listbox children; hide from AT (still visible).
    container.querySelectorAll('.algolia-rail__title').forEach(function (el) {
      el.setAttribute('aria-hidden', 'true');
    });
    var options = container.querySelectorAll(A11Y_OPTIONS);
    var idBase = (instance.input && instance.input.id ? instance.input.id : 'predictive') + '-option-';
    for (var i = 0; i < options.length; i++) {
      var opt = options[i];
      opt.setAttribute('role', 'option');
      opt.id = idBase + i;
      if (opt.getAttribute('aria-selected') !== 'true') opt.setAttribute('aria-selected', 'false');
      if (!opt.getAttribute('aria-label')) opt.setAttribute('aria-label', comboOptionLabel(opt));
    }
    if (instance.input) instance.input.setAttribute('aria-activedescendant', '');
    // Read the count text BEFORE neutralizing, so we can announce it below.
    var countEl = container.querySelector('.algolia-main__count');
    var countText = countEl ? (countEl.getAttribute('data-announce') || countEl.textContent.trim()) : '';
    // A listbox may only own option/group children. The injected count and
    // loading elements carry role="status", which is a disallowed listbox
    // child — strip their roles (we drive the input's own status region instead).
    container.querySelectorAll('[role="status"]').forEach(function (el) {
      el.setAttribute('role', 'presentation');
      el.removeAttribute('aria-live');
    });
    if (countText && typeof instance.setLiveRegionText === 'function') {
      instance.setLiveRegionText(countText);
    }
  }

  /* ── Element patch ─────────────────────────────────────────── */

  function initPatch() {
    if (typeof algoliasearch === 'undefined' || !window.customElements || !customElements.get('predictive-search')) {
      return false;
    }
    var cfg = getConfig();
    if (!cfg.app_id || !cfg.search_api_key) return false;

    var prefix = cfg.index_prefix || cfg.indexPrefix || 'shopify_';
    var productsIndexName = prefix + 'products';
    var collectionsIndexName = prefix + 'collections';
    // The Algolia Shopify app builds Query Suggestions into an index named
    // "Shopify Product Suggestion" (records: {query, popularity}, objectID ===
    // query). The prefix-derived name never existed, so the probe 404'd on
    // every page, the rail fell back to product titles, and clicks were sent
    // against a phantom index (audit 2026-09-18).
    var suggestionsIndexName = cfg.query_suggestions_index || 'Shopify Product Suggestion';

    var client = algoliasearch(cfg.app_id, cfg.search_api_key);
    var productsIndex = client.initIndex(productsIndexName);
    var collectionsIndex = client.initIndex(collectionsIndexName);

    var suggestionsIndex = null;
    var probe = client.initIndex(suggestionsIndexName);
    // Capability probe for the suggestions index, not a shopper search.
    probe.search('', { hitsPerPage: 0, analytics: false })
      .then(function () { suggestionsIndex = probe; })
      .catch(function () { suggestionsIndex = null; });

    var Klass = customElements.get('predictive-search');
    var proto = Klass.prototype;
    var originalRenderResults = proto.renderResults;
    var originalClose = proto.close;

    function keepProduct(hit) {
      var tags = hit.tags || hit._tags || [];
      if (typeof tags === 'string') tags = tags.split(',');
      for (var i = 0; i < tags.length; i++) {
        var tg = String(tags[i]).trim().toLowerCase();
        for (var j = 0; j < EXCLUDED_TAGS.length; j++) {
          if (tg === EXCLUDED_TAGS[j].toLowerCase()) return false;
        }
      }
      var title = (hit.title || '').toLowerCase();
      for (var k = 0; k < EXCLUDED_TITLE_PATTERNS.length; k++) {
        if (title.indexOf(EXCLUDED_TITLE_PATTERNS[k]) !== -1) return false;
      }
      return true;
    }

    /**
     * What the panel shows before anyone types.
     *
     * Seeded from the products this shopper has actually looked at
     * (cc-recently-viewed), falling through to Trending for a first-time
     * visitor. Algolia's own recommended-for-you model would be the ideal
     * source but needs Personalization, which is not enabled on this account.
     *
     * Returns the same shape as an index.search() response so the renderers
     * downstream do not need to care which one produced it.
     */
    function recommendOpenState() {
      var RSRecs = window.RSRecsEngine;
      var empty = { hits: [], nbHits: 0, queryID: null, __personalised: false };
      if (!RSRecs || !RSRecs.fetchRecommendations) return Promise.resolve(empty);

      var recentlyViewed = [];
      try {
        recentlyViewed = (JSON.parse(localStorage.getItem('cc-recently-viewed') || '[]') || []).slice(0, 5);
      } catch (e) {
        recentlyViewed = [];
      }

      return RSRecs.resolveSeedObjectIds(productsIndex, recentlyViewed)
        .then(function (seeds) {
          var models = seeds.length
            ? ['related-products', 'looking-similar', 'trending-items']
            : ['trending-items'];
          return RSRecs.fetchRecommendations({
            models: models,
            seeds: seeds,
            maxSeeds: 3,
            limit: 24,
            excludeProductIds: recentlyViewed,
            attributesToRetrieve: [
              'id', 'title', 'handle', 'image', 'product_image', 'price',
              'variants_min_price', 'variants_max_price', 'objectID', 'vendor',
              'product_type', 'tags', '_tags'
            ]
          }).then(function (result) {
            var hits = (result && result.hits) || [];
            return {
              hits: hits,
              nbHits: hits.length,
              queryID: null, // per-hit queryIDs ride on hit.__queryID
              __personalised: seeds.length > 0 && hits.length > 0
            };
          });
        })
        .catch(function () { return empty; });
    }

    /*
     * Impressions for what the panel just rendered, so the Search Panel has a
     * denominator for its clicks (it reported clicks with no views before
     * 2026-09-18). As-you-type re-renders on every keystroke, so each
     * objectID is reported once per panel session (reset on close) and the
     * send is debounced. Open-state Recommend cards go through the shared
     * recs helper so they read as "Recs <Model> Viewed (Search Panel)";
     * search hits go out as plain viewedObjectIDs.
     */
    function trackPanelImpressions(instance, state, data) {
      if (typeof window.aa !== 'function' || !data || !data.products || !data.products.length) return;
      var seen = instance._algoliaViewed || (instance._algoliaViewed = {});
      var fresh = [];
      for (var i = 0; i < Math.min(data.products.length, 24); i++) {
        var hit = data.products[i];
        if (!hit || !hit.objectID || seen[hit.objectID]) continue;
        seen[hit.objectID] = true;
        fresh.push(hit);
      }
      if (!fresh.length) return;
      if (instance._algoliaViewTimer) clearTimeout(instance._algoliaViewTimer);
      var pending = (instance._algoliaViewPending || []).concat(fresh);
      instance._algoliaViewPending = pending;
      instance._algoliaViewTimer = setTimeout(function () {
        instance._algoliaViewTimer = null;
        instance._algoliaViewPending = [];
        var recs = pending.filter(function (h) { return h.__model; });
        var searchHits = pending.filter(function (h) { return !h.__model; });
        if (recs.length && window.RSRecsEngine && window.RSRecsEngine.trackRecsView) {
          window.RSRecsEngine.trackRecsView(recs, { indexName: data.indexName, surface: 'search' });
        }
        for (var j = 0; j < searchHits.length; j += 20) {
          aa('viewedObjectIDs', {
            index: data.indexName,
            eventName: 'Products Viewed (Autocomplete)',
            objectIDs: searchHits.slice(j, j + 20).map(function (h) { return String(h.objectID); })
          });
        }
      }, 400);
    }

    async function fetchAndRender(state) {
      var instance = this;
      setupOverlay(instance);
      try {
        // Opening the panel is not a search. Sending an empty query made it the
        // highest-volume "query" on the account with a near-zero conversion
        // rate, which dragged down every account-wide metric. Recommend instead:
        // no query is recorded, and the rail becomes personal.
        var productsPromise = state.isEmpty
          ? recommendOpenState()
          : productsIndex.search(state.query, withUser({
            hitsPerPage: 24,
            clickAnalytics: true,
            filters: buildExclusionFilters(),
            attributesToRetrieve: [
              'id', 'title', 'handle', 'image', 'product_image', 'price',
              'variants_min_price', 'variants_max_price', 'objectID', 'vendor',
              'product_type', 'tags', '_tags'
            ]
          }));

        var suggestionsPromise = suggestionsIndex
          ? suggestionsIndex.search(state.query, withUser({ hitsPerPage: 6, clickAnalytics: true })).catch(function () { return null; })
          : Promise.resolve(null);

        var collectionsPromise;
        if (state.isEmpty) {
          collectionsPromise = Promise.resolve({ hits: getConfig().default_collections || [] });
        } else {
          collectionsPromise = collectionsIndex
            .search(state.query, withUser({ hitsPerPage: 6, clickAnalytics: true }))
            .catch(function () { return null; });
        }

        var results = await Promise.all([productsPromise, suggestionsPromise, collectionsPromise]);
        var productsRes = results[0] || { hits: [] };
        var suggestionsRes = results[1];
        var collectionsRes = results[2];

        if (instance._algoliaState !== state) return; // superseded by newer query

        var filtered = (productsRes.hits || []).filter(keepProduct);

        var data = {
          products: filtered,
          nbHits: productsRes.nbHits,
          queryID: productsRes.queryID || null,
          indexName: productsIndexName,
          personalised: productsRes.__personalised === true,
          suggestions: suggestionsRes ? suggestionsRes.hits : null,
          suggestionsQueryID: suggestionsRes ? (suggestionsRes.queryID || null) : null,
          suggestionsIndexName: suggestionsIndexName,
          collections: collectionsRes ? collectionsRes.hits : null,
          collectionsQueryID: collectionsRes ? (collectionsRes.queryID || null) : null,
          collectionsIndexName: collectionsIndexName
        };

        var markup;
        if (state.isMobile) {
          markup = state.isEmpty ? buildMobileEmpty(state, data) : buildMobileResults(state, data);
        } else {
          markup = buildDesktop(state, data);
        }

        originalRenderResults.call(instance, markup);
        enhanceComboboxA11y(instance);
        trackPanelImpressions(instance, state, data);
      } catch (e) {
        if (window.console && console.error) console.error('[algolia-predictive]', e);
      }
    }

    proto.getResults = async function (searchTerm) {
      if (searchTerm == null) {
        if (typeof originalClose === 'function') originalClose.call(this);
        this._algoliaState = null;
        this._algoliaViewed = null;
        if (this._algoliaViewTimer) { clearTimeout(this._algoliaViewTimer); this._algoliaViewTimer = null; }
        this._algoliaViewPending = [];
        return;
      }
      var term = String(searchTerm).trim();
      if (typeof this.setLiveRegionLoadingState === 'function') this.setLiveRegionLoadingState();
      this._algoliaFocusRestore = document.activeElement;
      var state = {
        query: term,
        isEmpty: term.length === 0,
        isMobile: isMobileViewport()
      };
      this._algoliaState = state;
      await fetchAndRender.call(this, state);
    };

    // Re-render the open panel when the viewport crosses the mobile/desktop
    // boundary so the markup (grid vs. list) always matches the CSS layout.
    if (!proto._algoliaResizeBound) {
      proto._algoliaResizeBound = true;
      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          var open = document.querySelector('predictive-search[open]');
          if (!open || !open._algoliaState) return;
          if (open._algoliaState.isMobile === isMobileViewport()) return;
          open._algoliaState.isMobile = isMobileViewport();
          fetchAndRender.call(open, open._algoliaState);
        }, 150);
      });
    }

    proto.close = function (evt) {
      this._closing = true;
      this._algoliaState = null;
      var form = this.querySelector && this.querySelector('.search--algolia');
      if (form) form.classList.remove('algolia-overlay');
      if (typeof originalClose === 'function') originalClose.call(this, evt);
      var focusTarget = this._algoliaFocusRestore;
      this._algoliaFocusRestore = null;
      if (focusTarget && focusTarget !== this.input && typeof focusTarget.focus === 'function' && document.body.contains(focusTarget)) {
        focusTarget.focus();
      }
    };

    // Keyboard navigation for the ARIA combobox: move aria-activedescendant
    // across the flat listbox options; Enter activates the active option;
    // Escape closes; with no active option Enter falls through to native
    // form submit (→ /search?q=…). Overrides the theme defaults, which target
    // legacy tab/panel markup Algolia never renders.
    proto.handleResultsNav = function (key) {
      var options = this.results ? this.results.querySelectorAll('[role="option"]') : [];
      if (!options.length) return;
      var current = this.results.querySelector('[role="option"][aria-selected="true"]');
      var idx = -1;
      for (var i = 0; i < options.length; i++) { if (options[i] === current) { idx = i; break; } }
      var nextIdx;
      if (key === 'ArrowDown') nextIdx = (idx + 1) % options.length;
      else if (key === 'ArrowUp') nextIdx = (idx <= 0 ? options.length - 1 : idx - 1);
      else return;
      var next = options[nextIdx];
      if (current && current !== next) current.setAttribute('aria-selected', 'false');
      next.setAttribute('aria-selected', 'true');
      if (this.input) this.input.setAttribute('aria-activedescendant', next.id);
      if (next.scrollIntoView) next.scrollIntoView({ block: 'nearest' });
      if (typeof this.setLiveRegionText === 'function') {
        this.setLiveRegionText(next.getAttribute('aria-label') || next.textContent.trim());
      }
    };

    proto.selectOption = function () {
      var active = this.results && this.results.querySelector('[role="option"][aria-selected="true"]');
      if (active) active.click();
    };

    proto.handleKeydown = function (evt) {
      switch (evt.key) {
        case 'ArrowDown':
        case 'ArrowUp':
          if (this.hasAttribute('open')) { evt.preventDefault(); this.handleResultsNav(evt.key); }
          break;
        case 'Enter':
          var active = this.results && this.results.querySelector('[role="option"][aria-selected="true"]');
          if (active) { evt.preventDefault(); active.click(); }
          break;
        case 'Escape':
          this.close();
          break;
        // no default
      }
    };

    // Delegated interaction handling — attached once per element, survives
    // re-renders (listener lives on the element, innerHTML swaps beneath it).
    var names = { productsIndexName: productsIndexName, collectionsIndexName: collectionsIndexName, suggestionsIndexName: suggestionsIndexName };
    document.querySelectorAll('predictive-search').forEach(function (el) {
      wireInteractions(el, names);
    });

    return true;
  }

  function wireInteractions(el, names) {
    if (!el || el._algoliaInteractionsWired) return;
    el._algoliaInteractionsWired = true;

    el.addEventListener('click', function (e) {
      var card = e.target.closest('.algolia-card, .algolia-row');
      if (card) {
        var objectID = card.getAttribute('data-algolia-objectid');
        var position = parseInt(card.getAttribute('data-algolia-position'), 10) || 1;
        var queryID = card.getAttribute('data-algolia-queryid');
        var indexName = card.getAttribute('data-algolia-index');
        var model = card.getAttribute('data-algolia-model');

        // Cards in the open state come from Recommend, not from a search, so
        // they report as recommendations and are attributed separately.
        if (model && window.RSRecsEngine && window.RSRecsEngine.trackRecsClick) {
          window.RSRecsEngine.trackRecsClick(
            { objectID: objectID, __queryID: queryID, __model: model, id: card.getAttribute('data-algolia-productid') || '' },
            { indexName: indexName, surface: 'search', position: position }
          );
          return;
        }

        if (typeof window.aa === 'function' && queryID && objectID && indexName) {
          aa('clickedObjectIDsAfterSearch', {
            index: indexName,
            eventName: 'Product Clicked from Search',
            queryID: queryID,
            objectIDs: [objectID],
            positions: [position]
          });
        }
        if (queryID && objectID && window.rsAlgoliaAttribution) {
          window.rsAlgoliaAttribution.remember({
            objectID: objectID,
            queryID: queryID,
            productId: card.getAttribute('data-algolia-productid') || '',
            indexName: indexName,
            source: 'search'
          });
        }
        return;
      }

      var link = e.target.closest('.algolia-rail__link');
      if (!link) return;

      var collectionUrl = link.getAttribute('data-algolia-collection');
      if (collectionUrl) {
        var colObjectID = link.getAttribute('data-algolia-objectid');
        var colQueryID = link.getAttribute('data-algolia-queryid');
        var colIndex = link.getAttribute('data-algolia-index') || names.collectionsIndexName;
        var colPosition = parseInt(link.getAttribute('data-algolia-position'), 10) || 1;
        if (typeof window.aa === 'function' && colObjectID) {
          // Live Algolia hit → attributable "after search" click; static
          // default-collection links have no objectID/queryID and stay silent.
          if (colQueryID) {
            aa('clickedObjectIDsAfterSearch', {
              index: colIndex,
              eventName: 'Collection Clicked from Search',
              queryID: colQueryID,
              objectIDs: [colObjectID],
              positions: [colPosition]
            });
          } else {
            aa('clickedObjectIDs', {
              index: colIndex,
              eventName: 'Collection Clicked',
              objectIDs: [colObjectID]
            });
          }
        }
        window.location.href = collectionUrl;
        return;
      }

      var term = link.getAttribute('data-algolia-suggestion');
      if (term) {
        // Only a real Query Suggestions hit is reportable; the product-title
        // fallback carries no objectID and stays silent.
        var sObjectID = link.getAttribute('data-algolia-objectid');
        var sQueryID = link.getAttribute('data-algolia-queryid');
        var sIndex = link.getAttribute('data-algolia-index') || names.suggestionsIndexName;
        var sPosition = parseInt(link.getAttribute('data-algolia-position'), 10) || 1;
        if (typeof window.aa === 'function' && sObjectID) {
          if (sQueryID) {
            aa('clickedObjectIDsAfterSearch', {
              index: sIndex,
              eventName: 'Suggestion Clicked from Search',
              queryID: sQueryID,
              objectIDs: [sObjectID],
              positions: [sPosition]
            });
          } else {
            aa('clickedObjectIDs', {
              index: sIndex,
              eventName: 'Suggestion Clicked from Search',
              objectIDs: [sObjectID]
            });
          }
        }
        var input = el.querySelector('.js-search-input') || document.querySelector('.js-search-input');
        if (input) {
          input.value = term;
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.focus();
        }
      }
    });
  }

  function start() {
    if (initPatch()) return;
    var attempts = 0;
    var timer = setInterval(function () {
      attempts += 1;
      if (initPatch() || attempts > 50) clearInterval(timer);
    }, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
